import React, {Component} from 'react';
import PropTyeps from 'prop-types';
import {observer} from 'mobx-react';
import {typoLight} from '../themes/colors';
import LooperPower from '../containers/create/looper/LooperPower';
import {PowerState} from '../constants/enums';
import VolumeSlider from './VolumeSlider';

@observer
class VolumeControl extends Component {
    render() {
        const {volume, onMuteChange, onVolumeChange, iconColor = typoLight, disabled, controlled = false, onHoverStart, onHoverEnd} = this.props;

        return (
            <div className="volume-control" onMouseEnter={onHoverStart} onMouseLeave={onHoverEnd}>
                <LooperPower
                    color={iconColor} onClick={onMuteChange} disabled={disabled}
                    powerState={volume > 0 ? PowerState.On : PowerState.Off}/>
                <VolumeSlider disabled={disabled && controlled} volume={volume} onChange={onVolumeChange}/>
            </div>
        );
    }
}

VolumeSlider.propTypes = {
    onMuteChange: PropTyeps.func,
    volume: PropTyeps.number,
    onVolumeChange: PropTyeps.func,
    iconColor: PropTyeps.string,
    disabled: PropTyeps.bool,
    controlled: PropTyeps.bool
};

export default VolumeControl;
